<!--
 * @Description: 教职工详情 岗位证书
 * @Author: 张天伟
 * @Date: 2023-03-08 17:08:04
 * @LastEditors: PF
 * @LastEditTime: 2025-12-22 14:58:34
-->

<template>
  <div>
    <el-descriptions v-for="(item, index) in tableData" :key="index" :column="4" border>
        <el-descriptions-item label="证书名称" label-align="right" align="left" width="120px" span="2">{{item.gwzsmc}}</el-descriptions-item>
        <el-descriptions-item label="证书编号" label-align="right" align="left" width="120px" span="2">{{item.gwzsbh}}</el-descriptions-item>
        <el-descriptions-item label="颁发单位" label-align="right" align="left" width="120px" span="2">{{item.bfdw}}</el-descriptions-item>
        <el-descriptions-item label="颁发日期" label-align="right" align="left" width="120px" span="2">{{item.bfrq}}</el-descriptions-item>
      </el-descriptions>
  </div>
</template>

<script setup>
import { ref, defineProps, watch } from 'vue'
import { actionPost } from '@/api/common.js'

const props = defineProps({ row: { type: Object, required: false } })
const tableData = ref()

watch(
  () => props.row,
  () => {
    if (props.row) {
      const o = { url: '/api/v2/renliziyuan/jiaozhigonggangweizhengshu/list', data: { id: props.row.id, order: 'gh', sort: 'asc' } }
      actionPost(o).then((res) => {
        tableData.value = res.data
      })
    }
  },
  { deep: true, immediate: true }
)
</script>
